module.exports = __webpack_public_path__ + "img/service-smart.54ac1c2.webp";